
function NotFound() {
    return(<>NOT FOUND</>);
}

export default NotFound;